import React, { useCallback } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import qs from 'querystring';

import { useAppContext } from '@prisjakt/ui-app-context';
import NewsletterSignup from '@prisjakt/ui-newsletter-signup';
import Modal from '../modal';

export const NEWSLETTER_PARAM = 'signup-for-our-newsletter';

const StyledNewsletterSignup = styled(NewsletterSignup)`
  width: 100%;
`;

type Props = {
  location: Location;
  history: {
    push: (location: Location) => void;
  };
};

type Location = {
  search: string;
};

const NewsLetterSignupModal = (props: Props) => {
  const { t } = useAppContext();

  const close = useCallback(() => {
    // Remove the `NEWSLETTER_PARAM` from the URL which closes the modal
    const location = props.location;
    const params = qs.parse(props.location.search.substr(1));
    delete params[NEWSLETTER_PARAM];
    location.search = qs.stringify(params);

    props.history.push(location);
  }, [props.history, props.location]);

  return (
    <Modal isOpen width={500} onRequestClose={close}>
      <StyledNewsletterSignup
        stacked
        title={t('footer', 'newsletter.title')}
        description={t('footer', 'newsletter.sub-title')}
      />
    </Modal>
  );
};

export default withRouter(NewsLetterSignupModal);
